// src/mixpanel.js
import mixpanel from "mixpanel-browser";
const projectToken = "313a452f33e0b3796e86020974627de9rir";

mixpanel.init(projectToken, { debug: true });

export const trackEvent = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
};
